module.exports = __webpack_public_path__ + "img/event_4_cover.c2aeff30.jpg";